import React from "react";
import { useI18n } from "../../lib/i18n/i18n_provider";
import { CheckIcon } from "./icons";
import { Divider } from "./divider";

interface GeneralInfoData {
  title: string;
  items: GeneralInfoItemData[];
}

interface GeneralInfoItemData {
  summary?: string; //TODO: remove
  description?: string; //TODO: remove
  htmlString?: string;
}

export function GeneralInfo(props: { html: string }) {
  const { html } = props;
  const data = parseData(html);
  const { fbt } = useI18n();

  return (
    <div data-testid="general-info" className="bs-general-info">
      {data.map((infoData, infoIndex) => {
        return (
          <>
            <h3>{infoData.title || fbt("generalInformation")}</h3>

            {infoData.items.map((item, itemIndex) => {
              const hasSummaryColumn = infoData.items.some(
                (item) => !!item.summary
              );

              return (
                <>
                  {/* Render items list items with formatted icon */}
                  {(item.description || item.summary) && (
                    <div
                      className={`row py-2 mx-1 general-information-item-wrapper ${
                        itemIndex !== infoData.items.length - 1
                          ? "border-bottom"
                          : ""
                      }`}
                      key={itemIndex}
                    >
                      <div className="col-1">
                        <CheckIcon className="bs-general-info__check-icon text-primary" />
                      </div>
                      <div className="col">
                        <div className="row">
                          <div
                            className={
                              hasSummaryColumn ? "col-12 col-md-4" : ""
                            }
                          >
                            {item.summary && (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.summary,
                                }}
                              />
                            )}
                          </div>
                          <div
                            className={
                              hasSummaryColumn ? "col-12 col-md-7" : "col"
                            }
                          >
                            {item.description && (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.description,
                                }}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Render html string */}
                  {item.htmlString && (
                    <div
                      dangerouslySetInnerHTML={{ __html: item.htmlString }}
                    />
                  )}
                </>
              );
            })}

            {data.length > 1 && infoIndex < data.length - 1 && <Divider />}
          </>
        );
      })}
    </div>
  );
}

// TODO: backward compatible with current GeneralInfo data from backend.
// Update backend and remove this code when all partners are fully migrated to V2
function parseData(htmlInputString: string): GeneralInfoData[] {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlInputString, "text/html");

  let sections = Array.from(doc.body.children);
  let data: GeneralInfoData[] = [];

  while (sections.length) {
    // Assume the first element will always be the title (h1, h2 or h3)
    let title = sections.shift()?.textContent || "";

    let items: GeneralInfoItemData[] = [];
    while (
      sections.length &&
      !["h1", "h2", "h3"].includes(sections[0].tagName.toLowerCase())
    ) {
      let element = sections.shift(); // Get the next element

      if (element && element.tagName.toLowerCase() === "ul") {
        // Check if the element is a list
        items = items.concat(
          Array.from(element.children).map((li) => {
            if (!li.innerHTML) {
              return {};
            }
            // Split the text content by '|' and trim the results
            const parts = li.innerHTML.split("|").map((str) => str.trim());
            let summary, description;
            if (parts.length > 1) {
              [summary, description] = parts;
              return { summary, description };
            }

            return { description: parts[0] };
          })
        );
      } else {
        // For non-list elements like p, div, span, render the plain html.
        let htmlString = element?.outerHTML;
        items.push({ htmlString });
      }
    }

    data.push({ title, items });
  }

  return data;
}
